"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerConnectionOverlay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const useStore_1 = require("../../store/useStore");
const lucide_react_1 = require("lucide-react");
require("./ServerConnectionOverlay.css");
const ServerConnectionOverlay = () => {
    const { isServerDisconnected, reconnectAttempt, isReconnecting, reconnectFailed, triggerReconnect } = (0, useStore_1.useStore)();
    (0, react_1.useEffect)(() => {
        const handleOffline = () => {
            useStore_1.useStore.getState().setServerDisconnected(true);
        };
        window.addEventListener('offline', handleOffline);
        return () => window.removeEventListener('offline', handleOffline);
    }, []);
    if (!isServerDisconnected)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { className: "server-connection-overlay", children: (0, jsx_runtime_1.jsxs)("div", { className: "server-connection-card", children: [(0, jsx_runtime_1.jsx)("div", { className: "connection-icon-wrapper", children: (0, jsx_runtime_1.jsx)(lucide_react_1.WifiOff, { className: "connection-icon pulse-red", size: 44 }) }), (0, jsx_runtime_1.jsx)("h2", { className: "connection-title", children: "Server Ba\u011Flant\u0131s\u0131 Koptu" }), isReconnecting && ((0, jsx_runtime_1.jsxs)("div", { className: "connection-status-container", children: [(0, jsx_runtime_1.jsxs)("p", { className: "connection-message", children: ["Tekrar deneniyor... ", (0, jsx_runtime_1.jsxs)("span", { className: "attempt-badge", children: ["attempt ", reconnectAttempt, "/3"] })] }), (0, jsx_runtime_1.jsx)("div", { className: "attempt-progress-dots", children: [1, 2, 3].map((step) => ((0, jsx_runtime_1.jsx)("div", { className: `dot ${step === reconnectAttempt ? 'active' : step < reconnectAttempt ? 'completed' : ''}` }, step))) }), (0, jsx_runtime_1.jsx)("div", { className: "spinner-wrapper", children: (0, jsx_runtime_1.jsx)(lucide_react_1.RefreshCw, { className: "spinner", size: 22 }) })] })), reconnectFailed && ((0, jsx_runtime_1.jsxs)("div", { className: "connection-failed-container", children: [(0, jsx_runtime_1.jsxs)("p", { className: "failed-text", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.AlertTriangle, { size: 16, className: "warning-icon" }), " Sunucuya ula\u015F\u0131lamad\u0131. L\u00FCtfen a\u011F ba\u011Flant\u0131n\u0131z\u0131 kontrol edip tekrar deneyiniz."] }), (0, jsx_runtime_1.jsxs)("button", { className: "retry-button", onClick: () => triggerReconnect(), children: [(0, jsx_runtime_1.jsx)(lucide_react_1.RefreshCw, { size: 16 }), " Tekrar Dene"] })] }))] }) }));
};
exports.ServerConnectionOverlay = ServerConnectionOverlay;
